import { render, staticRenderFns } from "./ObjectAttachment.vue?vue&type=template&id=5ef3a01a&scoped=true&"
import script from "./ObjectAttachment.vue?vue&type=script&lang=js&"
export * from "./ObjectAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAttachment.vue?vue&type=style&index=0&id=5ef3a01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3a01a",
  null
  
)

export default component.exports